// Per-page documentation content (Turkish). Each entry describes the page's
// purpose, how it is used, and which other pages it relates to.

export const PAGE_DOCS = {
  dashboard: {
    title: "Karşılama Ekranı (Dashboard)",
    icon: "🏠",
    purpose:
      "Sisteme giriş yaptıktan sonra gelen ana kontrol paneli. Şube yönetimi için tüm modülleri şık, modern ve ortalanmış bir düzen içinde sunar.",
    sections: [
      {
        heading: "Şube Yönetim Modülleri",
        items: [
          "**Personel Listem** — Şubedeki tüm çalışanların listelendiği, yeni kayıtların eklendiği ve düzenlendiği modül.",
          "**Personel İstifa Formu** — Ayrılan personeller için resmi A4 istifa dilekçesi hazırlama ve onaylama modülü.",
          "**Manav Listesi Girişi** — Günlük manav reyon sipariş miktarının girildiği ve A4 yazdırıldığı Excel benzeri alan.",
          "**Veri Girişi** — Avans, Mesai ve Kesinti bilgilerinin girildiği pratik muhasebe alanı.",
          "**Z-Rapor** — Gün sonu kasa Z-Raporu, POS tahsilatları, borç, gider ve şef ödemeleri takibi.",
        ],
      },
      {
        heading: "Tasarım & Etkileşim İpuçları",
        items: [
          "Modül kartları üzerindeki **Modüle Git →** ibaresine veya kartın kendisine tıklayarak ilgili sayfaya anında geçiş yapabilirsiniz.",
          "Kartlar üzerinde fareyi gezdirdiğinizde beliren **yukarı süzülme ve yumuşak ışıma (glow)** efektleri etkileşimli tasarımı destekler.",
          "Her modülün yanında ait olduğu departmanı gösteren mini renkli kurumsal etiketler (rozetler) bulunur.",
        ],
      },
      {
        heading: "Gezinme & Çıkış Yapma",
        items: [
          "Üst menü çubuğundaki sekmeleri kullanarak modüller arasında hızlıca geçiş yapabilirsiniz.",
          "Oturumunuzu güvenli bir şekilde kapatmak için sağ üstteki **🚪 Çıkış Yap** butonunu kullanabilirsiniz.",
        ],
      },
    ],
  },

  personel: {
    title: "Personel Listesi",
    icon: "👥",
    purpose:
      "Şubenizin seçilen yıl ve aydaki çalışan personel kadrosunu listelemek, aramak ve istifa işlemleri için hızlı erişim sağlamak amacıyla kullanılan izleme ve denetleme modülüdür.",
    sections: [
      {
        heading: "Bu sayfada neler yapabilirsiniz?",
        items: [
          "Üst kısımdaki **Yıl** ve **Ay** seçicilerini değiştirerek, şubenizin o dönemde aktif olan personel listesini sorgulayabilirsiniz.",
          "**Ara** kutusunu kullanarak personel adı, soyadı veya ID'sine göre anlık filtreleme yapabilirsiniz.",
          "Tablonun altında o döneme ait aktif çalışan **Toplam Personel** sayısını görebilirsiniz.",
          "Listeden bir personele **sağ tıklayarak (context menu)**, o personel için doğrudan **İstifa Formu** sayfasına geçiş yapabilir ve istifa dilekçesini doldurabilirsiniz.",
        ],
      },
      {
        heading: "İlişkili Sayfalar",
        items: [
          "**Personel İstifa Formu** — Sağ tık menüsü ile bu sayfaya geçiş yaparak resmi istifa dilekçesini A4 formatında yazdırabilirsiniz.",
          "**Veri Girişi** — Avans, Mesai ve Kesinti gibi finansal veri girişlerinde listedeki personeller seçilebilir.",
        ],
      },
    ],
  },


  devam: {
    title: "Personel Devam Listesi",
    icon: "📅",
    purpose:
      "Şube çalışanlarının Mobil QR, Kart ve Manuel yöntemlerle yaptığı işe giriş ve mesai çıkış kayıtlarını izleme ve manuel devam işlemleri yönetme modülüdür.",
    sections: [
      {
        heading: "Özellikler & Kullanım",
        items: [
          "**Devam Kayıtları Listesi**: Seçili tarihteki tüm giriş ve çıkış kayıtlarını, giriş/çıkış yöntemleri (Mobil QR, Kart, Manuel) ile listeler.",
          "**Manuel Giriş Aç**: İşe giriş kaydı açılmamış bir personel için manuel giriş saati ile yoklama kaydı başlatır.",
          "**Manuel Çıkış Yap**: Devam eden aktif bir yoklama kaydını seçilen mesai bitim saati ile kapatır.",
          "**Filtreleme & Arama**: Tarih seçici ve personel adı/soyadı arama kutusu ile anlık filtreleme sağlar.",
        ],
      },
    ],
  },

  istifa: {
    title: "Personel İstifa Formu",
    icon: "📄",
    purpose:
      "İstifa eden personel için resmi istifa dilekçesini hazırlamak ve geçmiş kayıtları yönetmek.",
    sections: [
      {
        heading: "Bu sayfada neler yapabilirsiniz?",
        items: [
          "Sol formdan personel seçin → **Giriş Tarihi** otomatik dolar.",
          "**Çıkış Tarihi (Son Çalışma)** ve İstifa Tarihi'ni girin.",
          "İhbar süresi, kıdem tazminatı, sebep ve açıklama bilgilerini doldurun.",
          "**🖨 Formu İndir / Yazdır** butonu A4 formatında resmi dilekçeyi yazıcıya/PDF'e gönderir.",
          "**Formu Kaydet** ile kayıt yapılır; sağ tabloda durumu (Beklemede/Onaylandı/Reddedildi) güncelleyebilirsiniz.",
        ],
      },
      {
        heading: "İlişkili Sayfalar",
        items: [
          "**Personel Listem** — sağ tık → *İstifa Formu Doldur* ile bu sayfaya personel önceden seçilmiş şekilde gelirsiniz.",
        ],
      },
    ],
  },

  manav: {
    title: "Manav Listesi Girişi",
    icon: "🥬",
    purpose:
      "Günlük manav reyonu için ürün-birim-miktar listesi oluşturma ve A4 olarak yazdırma.",
    sections: [
      {
        heading: "Bu sayfada neler yapabilirsiniz?",
        items: [
          "Sayfa A4 boyutunda kağıt görünümündedir; **iki sütuna** bölünmüştür.",
          "Her ürünün yanında **Birim** ve **Miktar** alanları vardır; sadece miktar girdiğiniz ürünler listeye dahil olur.",
          "Üstteki **Liste Adı** ve **Tarih** alanlarını doldurun.",
          "**💾 Kaydet** ile kayda alın, **🖨 Yazdır (A4)** ile çıktı alın (sadece kağıt yazdırılır, toolbar gizlenir).",
          "Sağdaki **📚 Geçmiş Manav Listeleri** panelinden eski listeleri açıp inceleyin veya silin.",
        ],
      },
      {
        heading: "Ürün Kataloğu",
        items: [
          "30+ varsayılan manav ürünü kataloğu (Domates, Salatalık, Patates, Elma, Muz, vs.) yarı yarıya iki sütuna dağıtılmıştır.",
        ],
      },
    ],
  },

  "veri-girisi": {
    title: "Veri Girişi (Avans / Mesai / Kesinti)",
    icon: "📊",
    purpose:
      "Personel bazlı **Avans, Mesai** ve **Kesinti Gün** kayıtlarını Excel benzeri tabloda tutar.",
    sections: [
      {
        heading: "Sekmeler ve Birimler",
        items: [
          "**Avans** — Tutar (₺) cinsinden",
          "**Mesai** — Saat cinsinden (0.5 adımlı)",
          "**Kesinti Gün** — Gün cinsinden",
        ],
      },
      {
        heading: "Bu sayfada neler yapabilirsiniz?",
        items: [
          "Üstteki **Ay / Yıl** seçicisi tüm sekmedeki kayıtların dönemini belirler — her satıra tarih girmek gerekmez.",
          "**Yeni Satır** ile bir kayıt ekleyin → personel seçin → tutar/saat/gün girin → açıklama yazın.",
          "Tüm değişiklikler **otomatik olarak bilgisayarınıza (tarayıcı hafızasına) kaydedilir**; sayfayı yenileseniz bile verileriniz korunur.",
          "**↺ Varsayılana Dön** butonu sekmenin bilgisayarınızdaki geçici hafızasını temizler ve varsayılan verileri yükler.",
          "Toolbar'daki yeşil 💾 simgesi otomatik kayıt göstergesidir.",
        ],
      },
      {
        heading: "İlişkili Sayfalar",
        items: [
          "**Personel Listem** — buradaki personeller her satırın açılır listesinde görünür.",
        ],
      },
    ],
  },
};

export const PAGE_DOCS_ZRAPOR_EXTRA = {
  zrapor: {
    title: "Z-Rapor Modülü",
    icon: "🧾",
    purpose:
      "Günlük kasa Z-Raporlarının girişi, geçmiş raporların listelenmesi, kasiyer bazlı kasa açık/fazla analizleri ve gün sonu kapatma işlemlerinin yapıldığı gelişmiş modül.",
    sections: [
      {
        heading: "Sekmeler & Temel Giriş",
        items: [
          "**Yeni Z-Rapor Girişi** — Günlük kasa kapanışında her kasa için ayrı rapor girişi yapın. Giriş alanları **Tab tuşu** ile sıralı şekilde hızlıca gezilebilir.",
          "**Geçmiş Raporlar** — Tarihe göre filtreleyip eski raporları görün, düzenleyin veya silin. Rapor listesinde kasiyer, kasa ve z-toplam doğrudan listelenir.",
          "**Tanımlar** — Kasiyer, Kasa, Banka, Gider Kategorisi ve Borç Müşterisi master kayıtlarını yönetin.",
        ],
      },
      {
        heading: "Kasiyer Bazlı Hesap Aktarımı (Drawer Analizi)",
        items: [
          "Yeni eklenen **Kasiyer Bazlı Aktarım** butonuna tıklayarak büyük bir sağ analiz paneli (drawer) açabilirsiniz.",
          "Belirtilen iki tarih arasındaki şubeye ait kasiyer açık ve fazla kayıtlarını belirtilen tutardan yüksek olacak şekilde filtreleyebilirsiniz.",
          "Filtreleme Tipleri: **Tümü (All)**, **Eşit (Equal)**, **Açık (Deficiency)** ve **Fazla (Excess)** kriterlerini destekler.",
          "**Verileri Dışa Aktar (PDF)** — Filtrelenen tüm kasiyer fark verilerini resmi PDF formatında dışa aktarabilirsiniz. PDF çıktısında tarayıcı ekleri (tarih, URL, sayfa sayıları) tamamen temizlenmiştir.",
        ],
      },
      {
        heading: "Gelişmiş PDF Çıktı & Tasarım Detayları",
        items: [
          "**Z-Toplam Alanı:** Dışa aktarımlarda Z-Toplam alanı siyah arka planlı ve kutunun sağına ve soluna tam olarak yaslanmış premium şerit olarak tasarlanmıştır.",
          "**Operasyon Detayları:** Numaralandırma kaldırılmış, son derece sade ve temiz bir tasarım ile gösterimi sağlanmıştır.",
          "**Temiz PDF Çıktısı:** Yazdırma ve PDF dışa aktarımlarında `localhost:3000`, tarih ve `1/1` gibi tarayıcı tarafından enjekte edilen gereksiz başlık ve dipnotlar tamamen temizlenmiştir.",
        ],
      },
      {
        heading: "Hesap Özeti & Fark Kontrolü",
        items: [
          "Sağ panelde **Tahsilat Toplamı = Nakit + Hediye + Banka POS + Borç** otomatik hesaplanır.",
          "**Fark = Toplam Tutar − Tahsilat Toplamı** anlık kontrol edilir; fark sıfırsa yeşil, değilse kırmızı uyarı gösterir.",
        ],
      },
      {
        heading: "Gün Kapatma & Veri Kalıcılığı",
        items: [
          "Geçmiş Raporlar sekmesinde tarih seçip **🔒 Günü Kapat & Gönder** ile o güne ait tüm açık raporları kapatabilirsiniz.",
          "Tüm veriler **bilgisayarınızın tarayıcı hafızasında** güvenle saklanır, sayfa yenilense bile kaybolmaz.",
        ],
      },
    ],
  },
};

Object.assign(PAGE_DOCS, PAGE_DOCS_ZRAPOR_EXTRA);

export const getDoc = (pageId) => PAGE_DOCS[pageId] || null;
